import { sp } from 'components/Analytics/components/SnowPlowAnalytics';
import createTagScript from 'helpers/createTagScript';
import sendDDLog from 'helpers/sendDDLog';

import { isScriptLoadedById } from '../../utils';

/**
 * @type {import('../../@types').InitAnalyticsType['gtm']}
 */

/**
 * Alias to datalayer.push can be used to set variables on the datalayer or directly send events to GTM
 * @type {import('../../@types').SendType}
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function send() {
  window.dataLayer = window.dataLayer || [];

  const [first] = Array.prototype.slice.call(arguments);
  if (typeof first === 'object') {
    window.dataLayer.push(first);
    return;
  }

  window.dataLayer.push(arguments);
}

/**
 * @type {import('../../@types').InitType}
 */
const init = ({ gtm }) => {
  if (!gtm || isScriptLoadedById(`gtag-script`)) {
    return;
  }

  if (gtm.initialDataLayer) {
    gtm.initialDataLayer?.forEach((data) => send(data));
  }

  const date = new Date();
  send('js', date);

  createTagScript(
    'gtag-script',
    `//www.googletagmanager.com/gtm.js?id=${gtm.id}&gtm_cookies_win=x`
  );
};

/**
 *
 * @type {import('../../@types').SendEventType}
 */
const sendEvent = async (evt) => {
  const { name, type, ...props } = evt;

  if (!props.eventGA4Name) {
    props.eventGA4Name = name;
  }

  if (!name && !props.event) {
    console.warn('blocking event without name', props);
    return;
  }

  window.__GDM_DATALAYER_FIELDS__ = window.__GDM_DATALAYER_FIELDS__ || {
    eventName: null,
  };

  const {
    engagementComponent,
    engagementDestination,
    engagementDetails,
    event,
    transactionId,
  } = props;

  const finalEvent = {
    ...window.__GDM_DATALAYER_FIELDS__,
    event:
      event ??
      `getapp-${engagementComponent}|${engagementDestination}|${engagementDetails}`,
    ...(!props.event && { eventName: name }),
    ...props,
  };

  send(finalEvent);

  if (transactionId) {
    sp.trackPPCClickEvent(finalEvent);
  }

  if (!event && props.eventGA4Name === 'engagement_product_clickout') {
    sendDDLog(
      `ga4=${props.eventGA4Name}&e=${engagementComponent}|${engagementDestination}|${engagementDetails}&t=${type}&tid=${transactionId}`
    );
  }

  window.__GDM_DATALAYER_FIELDS__ = Object.keys(props).reduce((acc, key) => {
    return {
      ...acc,
      [key]: null,
    };
  }, window.__GDM_DATALAYER_FIELDS__);
};

const sendPage = async (props) => {
  // @ts-ignore
  await sendEvent({ ...props, event: 'pageView', name: 'pageView' });
};

export default {
  init,
  send,
  sendEvent,
  sendPage,
};
